export default angular.module('articles_setup_module',['suggested_links_module']);